import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { Logo } from "../ui/Logo";
import { headerHeight } from "./constants";

export function AppHeader({ onMenuClick }: { onMenuClick?: () => void }) {
    const { t } = useTranslation();
    return (
        <AppBar
            position="sticky"
            color="inherit"
            elevation={0}
            sx={{
                borderLeft: "none",
                borderBottom: (t) =>
                    `1px solid ${alpha(t.palette.divider, 0.5)}`,
                borderRadius: 0,
            }}
        >
            <Toolbar sx={{ height: headerHeight }} style={{ paddingRight: 10 }}>
                <IconButton
                    onClick={onMenuClick}
                    edge="start"
                    sx={{ display: { xs: "inline-flex", md: "none" } }}
                    aria-label={t("nav.open-menu")}
                >
                    <MenuIcon />
                </IconButton>
                <Box sx={{ flex: 1 }} />
                <Box sx={{ display: "flex", alignItems: "right" }}>
                    <Logo />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
